var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSerIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.5 12.1875C26.9875 12.1875 26.5625 11.7625 26.5625 11.25V8.75C26.5625 5.525 24.475 3.4375 21.25 3.4375H8.75C5.525 3.4375 3.4375 5.525 3.4375 8.75V11.25C3.4375 11.7625 3.0125 12.1875 2.5 12.1875C1.9875 12.1875 1.5625 11.7625 1.5625 11.25V8.75C1.5625 4.45 4.45 1.5625 8.75 1.5625H21.25C25.55 1.5625 28.4375 4.45 28.4375 8.75V11.25C28.4375 11.7625 28.0125 12.1875 27.5 12.1875Z",
    fill: "#cf3d31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.25 28.4375H8.75C4.45 28.4375 1.5625 25.55 1.5625 21.25V18.75C1.5625 18.2375 1.9875 17.8125 2.5 17.8125C3.0125 17.8125 3.4375 18.2375 3.4375 18.75V21.25C3.4375 24.475 5.525 26.5625 8.75 26.5625H21.25C24.475 26.5625 26.5625 24.475 26.5625 21.25V18.75C26.5625 18.2375 26.9875 17.8125 27.5 17.8125C28.0125 17.8125 28.4375 18.2375 28.4375 18.75V21.25C28.4375 25.55 25.55 28.4375 21.25 28.4375Z",
    fill: "#cf3d31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10.2625L15.8 7.72495C15.3 7.46245 14.7125 7.46245 14.2125 7.72495L9.51253 10.2625C9.17503 10.45 8.96252 10.8124 8.96252 11.2249C8.96252 11.6374 9.17503 12 9.51253 12.1875L14.2125 14.725C14.4625 14.8625 14.7375 14.925 15.0125 14.925C15.2875 14.925 15.5625 14.8625 15.8125 14.725L20.5125 12.1875C20.85 12 21.0625 11.6374 21.0625 11.2249C21.05 10.8124 20.8375 10.45 20.5 10.2625Z",
    fill: "#cf3d31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.425 15.5875L9.04999 13.4C8.71249 13.2375 8.32497 13.2501 7.99997 13.4501C7.67497 13.6501 7.48749 13.9875 7.48749 14.3625V18.5C7.48749 19.2125 7.88749 19.8626 8.52499 20.1751L12.9 22.3626C13.05 22.4376 13.2125 22.475 13.3875 22.475C13.5875 22.475 13.775 22.425 13.95 22.3125C14.275 22.1125 14.4625 21.775 14.4625 21.4V17.2625C14.4625 16.55 14.075 15.9125 13.425 15.5875Z",
    fill: "#cf3d31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9875 13.4501C21.6625 13.2501 21.275 13.2375 20.9375 13.4L16.5625 15.5875C15.925 15.9125 15.525 16.55 15.525 17.2625V21.4C15.525 21.775 15.7125 22.1125 16.0375 22.3125C16.2125 22.425 16.4 22.475 16.6 22.475C16.7625 22.475 16.925 22.4376 17.0875 22.3626L21.4625 20.1751C22.1 19.8501 22.5 19.2125 22.5 18.5V14.3625C22.5 13.9875 22.3125 13.6501 21.9875 13.4501Z",
    fill: "#cf3d31"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerIcon03);
export default __webpack_public_path__ + "static/media/ser-icon03.3abe845fa7934f1e0df9fb1c1089d877.svg";
export { ForwardRef as ReactComponent };